import React from 'react';
import ReactDOM from 'react-dom';
import MainApp from './mainApp';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './App.css'
import { createRoot } from 'react-dom/client';
import { messaging, messagingPromise} from './firebase-config';
import { NotificationProvider } from './context/NotificationContext';
import { setupServiceWorkerMessageListener } from './utils/serviceWorkerUtils';
import ReactGA from 'react-ga4';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
      .register('/firebase-messaging-sw.js')  // This should match the location in the public folder
      .then(function (registration) {
          console.log('Service Worker registered:', registration);
          messagingPromise.useServiceWorker(registration);  // Use the service worker for Firebase messaging
      })
      .catch(function (error) {
          console.log('Service Worker registration failed:', error);  // This will log any registration errors
      });
}

// Setup service worker message listener once
setupServiceWorkerMessageListener();
//GA4 google analytics
 if (window.location.pathname.startsWith("/consumer")) {
  const GA4_ANALYTICS_MEASUREMENTID = process.env.REACT_APP_GA4_GOOGLE_ANALYTICS_MEASUREMENTID
  //console.log('GA4_ANALYTICS_MEASUREMENTID', GA4_ANALYTICS_MEASUREMENTID)
   ReactGA.initialize(GA4_ANALYTICS_MEASUREMENTID);
 }

const root = document.getElementById('root');
const rootContainer = createRoot(root);
rootContainer.render(
  <React.StrictMode>
    <BrowserRouter>
    <NotificationProvider>

      <MainApp />

      </NotificationProvider>

    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
